module.exports = __webpack_public_path__ + "media/images/vector-48@2x-64b9aa79ef4550522160a7323e96cde5.png";